import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { theme as defaultTheme } from "@miro-site/design-tokens";
var colors = {
    secondary4: "#F5F5F7",
    secondary8: "#EBEBEF",
    secondary20: "#CDCCD7",
    secondary40: "#9B99AF",
    secondary60: "#5F5C80",
    gray: "#686786"
};
var templates = {
    buttons: {
        transparent: {
            color: defaultTheme.colors.primaryIndigo,
            border: "1px solid ".concat(colors.secondary20),
            background: "transparent",
            ":hover": {
                borderColor: "transparent",
                color: defaultTheme.colors.primaryWhite,
                background: defaultTheme.colors.primaryBlueHover
            },
            ":focus": _object_spread({}, defaultTheme.focus.outlines.default)
        }
    },
    colors: colors,
    elevation: {
        overlay: "2px 4px 16px rgba(0, 0, 0, 0.1)",
        topBar: "0px 4px 12px rgba(5, 0, 56, 0.07)",
        fixedSearch: "0px 4px 12px rgba(5, 0, 56, 0.12)"
    }
};
var miroverseHighlighted = {
    container: {
        verticalPadding: 20,
        horizontalPadding: 20,
        radius: 10,
        background: colors.secondary4
    },
    title: {
        as: "h4",
        variant: "p2",
        fontWeight: 500,
        color: "primaryIndigo",
        margins: {
            afterTitle: [
                null,
                12
            ]
        }
    },
    itemContainer: {
        verticalPadding: 15,
        link: {
            dividerColor: "lightGray"
        },
        itemTitle: {
            fontSize: 14,
            lineHeight: 18,
            color: "primaryIndigo"
        },
        itemDescription: {
            fontSize: 12,
            lineHeight: 20,
            color: colors.gray
        },
        imageWidth: "100%",
        margins: {
            afterImage: "5%"
        }
    },
    actionLink: {
        variant: "regular",
        color: "default",
        size: "default",
        withArrow: true,
        fontSize: 14,
        fontWeight: 400,
        margins: {
            beforeLink: 15
        }
    }
};
var theme = _object_spread_props(_object_spread({}, defaultTheme), {
    templates: templates,
    miroverseHighlighted: miroverseHighlighted
});
export default theme;
